function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.23 7.297a9.167 9.167 0 1 0 0 18.334 9.167 9.167 0 0 0 0-18.334Zm0 16.5a7.333 7.333 0 1 1 0-14.667 7.333 7.333 0 0 1 0 14.667Zm0-10.084a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Zm0 3.667a.917.917 0 1 1 0-1.834.917.917 0 0 1 0 1.834Z",
  fill: "#F2F2F2"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16.465,
  r: 15.273,
  stroke: "url(#1234alfa)",
  strokeWidth: 1.455,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "1234alfa",
  x1: 34.449,
  y1: 33.424,
  x2: 0,
  y2: 33.424,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E64B4B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.188,
  stopColor: "#F3795E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.359,
  stopColor: "#E4BC5C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.526,
  stopColor: "#39D68D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.682,
  stopColor: "#37B1E4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.844,
  stopColor: "#874FC6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F05576"
})));

function SvgIconDistroColorido(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistroColorido);
export default __webpack_public_path__ + "static/media/icon-distro-colorido.83092edf8362672ab37088505777f286.svg";
export { ForwardRef as ReactComponent };